import React from 'react';
import PropTypes from 'prop-types';

import styles from './ListColumn.scss';

const ListColumn = ({
  id,
  sortValue,
  children,
  size,
  isHeader,
  sortHandler,
}) => {
  const divProps = {
    className: `ListColumn ListColumn--${id}`,
    'data-size': size,
  };
  if (sortValue && !isHeader) divProps['data-sort-value'] = sortValue;

  if (isHeader) {
    divProps.className += ' ListColumn--header';
    divProps.onClick = () => sortHandler(id);
    divProps.onKeyDown = e => {
      if (e.key === 'Enter') sortHandler(id);
    };
    divProps.role = 'columnheader';
    divProps.tabIndex = 0;
  }

  return <div {...divProps}>{children}</div>;
};

ListColumn.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  sortValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isHeader: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'med', 'lg']),
  sortHandler: PropTypes.func,
};

ListColumn.defaultProps = {
  isHeader: false,
  size: 'sm',
};

export default ListColumn;
